import { createStore } from 'jotai';
import { type ReactNode } from 'react';

export const filterListBottomSheetStore = createStore();

/**
 * - FILTER_LIST 바텀시트 atomic 전용 store
 * - `useFilterListBottomSheetAtom`이 `filterListBottomSheetStore`를 직접 참조하므로
 *   Jotai `<Provider>` 래핑은 불필요하며, 래핑 시 자식 트리의 다른 atom 조회까지
 *   가로채는 부작용이 있어 단순 passthrough로 유지함
 */
export const FilterListBottomSheetAtomProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  return <>{children}</>;
};
